module.exports = __webpack_public_path__ + "static/media/16UNODC16.147652d8.jpg";